<template>
  <div id="acomodos" class="mb-4 ">
    <SectionTitle
      class="my-3"
      :has-line="true"
      :title="'Acomodo Razonables brindados'"
    />

    <ValidationProvider
      v-slot="{ validate, errors }"
      :rules="{ required: { allowFalse: false } }"
    >
      <div class="container-table-striped divpanelacomodos">
        <div>
          <table class="col-12">
            <tbody>
              <tr
                v-for="(item, name) in selectedGrouped"
                :key="name"
                class="row rowAcomodo mx-0"
                :class="{ 'bg-gray': isBackgroundGray }"
              >
                <td class="col-md-3 text-left d-flex align-items-center">
                  <div class="mt-4">
                    <b class="bold">
                      <span>{{ name }}</span>
                    </b>
                  </div>
                </td>
                <td class="col-md-7 text-left">
                  <div class="text-muted mx-1 pt-2">
                    <span>Acomodos:</span>
                  </div>

                  <div class="row mx-0">
                    <BadgeTitle
                      v-for="x in item"
                      :key="x.id"
                      :class="'d-block'"
                      :title="x.name"
                      :highlight="x.highlight"
                      :has-icon="isReadOnly"
                      @delete="RemoveHandler(x)"
                    />
                  </div>
                </td>
                <td
                  v-if="!isReadOnly"
                  class="mt-4 py-2 col-md-2 right-padding d-sm-flex d-xs-flex "
                >
                  <div class="offset-md-6 col-md-6 px-0 pl-2">
                    <ActionButton
                      id="btnCancelDocument"
                      variant="outline-danger mr-2"
                      i="fas fa-times-circle"
                      :responsive="true"
                      @click="RemoveArrangementHandler(item)"
                    >
                      Eliminar
                    </ActionButton>
                  </div>
                </td>
              </tr>
            </tbody>
            <tfoot v-if="arrangement.isModified == false">
              <tr
                v-if="!hasArrangements"
                class="bg-light-gray border-radius--light text-center col-12"
              >
                <div class="col-md-12">
                  <button
                    id="btnFA"
                    :disabled="isReadOnly"
                    class="btn bg-light-white pt-1 mb-3 mt-3 col-12 col-md-6 col-lg-6"
                    @click="ModifyHandler()"
                  >
                    <i class="fas fa-file-plus pr-4 text-green" />
                    <span class="text-button-add-document">
                      Presione aquí para añadir acomodos
                    </span>
                  </button>
                </div>
              </tr>
              <tr v-if="!isReadOnly && hasArrangements" class="row">
                <div
                  class="align-items-end d-flex justify-content-end col-12 m-1"
                >
                  <ActionButton
                    variant="success m-1"
                    i="fas fa-file-plus pr-2"
                    :responsive="false"
                    @click="ModifyHandler()"
                  >
                    Añadir
                  </ActionButton>
                </div>
              </tr>
            </tfoot>
          </table>
        </div>
        <div v-if="arrangement.isModified == true" class="rowAcomodoform py-3">
          <div class="col-12">
            <label class="input-label">
              Área:
            </label>
            <CustomDropDown
              v-model="selectedArea"
              placeholder="Seleccione área"
              fieldkey="id"
              fieldname="name"
              :options="areaList"
              class="w-100 mb-3"
              @input="FilterHandler()"
            />
          </div>
          <div class="col-12">
            <multiSelect
              :all-items="strategyList"
              :item-type-name="'estrategia'"
              :selected-items="arrangement.temporary"
              :column-count="1"
              :isbgwhite="true"
              @itemSelected="OnItemSelectedHandler"
            />
          </div>
          <WarningBox
            class=" alert-warning ml-1 mt-1"
            title="Puede seleccionar uno (1) o más acomodos. Selección múltiple."
            inline
          />
          <div class="col-12">
            <div class="col-12">
              <h6 class="text-muted">
                Acomodos seleccionados:
              </h6>
            </div>
            <div class="panel col-12">
              <BadgeTitle
                v-for="(item, index) in arrangement.temporary"
                :key="index"
                :title="item.name"
                :highlight="item.highlight"
                :has-icon="isReadOnly"
                @delete="RemoveTempHandler(item)"
              />
            </div>
          </div>
          <div class="row mt-3 padding-10 ">
            <div
              class="align-items-end d-flex justify-content-end col-12 col-md-2 offset-md-10"
            >
              <action-button
                variant="outline-danger m-1"
                :i="`fas fa-times-circle`"
                :responsive="true"
                @click="CloseHandler()"
              >
                Cancelar
              </action-button>
              <action-button
                variant="success m-1"
                :i="`fas fa-file-plus`"
                :responsive="true"
                @click="
                  SaveHandler();
                  validate(hasArrangements);
                "
              >
                Añadir
              </action-button>
            </div>
          </div>
        </div>
      </div>
      <input v-model="hasArrangements" type="hidden" />
      <Error
        v-if="errors[0]"
        variant="no-border"
        message="Favor añadir al menos un acomodo razonable."
      />
    </ValidationProvider>
  </div>
</template>

<script>
import SectionTitle from 'SectionTitle';
import mixAlert from '@/mixin/alert.mixin';
import mixWait from '@/mixin/loading.mixin';
import multiSelect from '@/components/common/MultiSelectionPicker';
import { CustomDropDown, Error } from '@/components/common';
import { BadgeTitle } from '@/components/pei/shared';
import { WarningBox } from '@/components/pei/tabs/components/tab8';
import ActionButton from 'ActionButton';

export default {
  name: 'LearningArrangement',
  mixins: [mixAlert, mixWait],
  components: {
    SectionTitle,
    multiSelect,
    BadgeTitle,
    WarningBox,
    CustomDropDown,
    ActionButton,
    Error,
  },
  data() {
    return {
      Info: {},
      selectedArea: null,
      strategyList: [],
    };
  },
  props: {
    model: {
      type: Object,
      required: true,
    },
    arrangement: {
      type: Object,
      required: true,
    },
    areaList: {
      type: Array,
      required: true,
    },
    isReadOnly: {
      type: Boolean,
      default: false,
    },
    isBackgroundGray: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    selectedGrouped() {
      let grouped_ = this.model.arrangements.reduce((r, a) => {
        if (a.area !== undefined && a.area.name !== undefined) {
          r[a.area.name] = [].concat.apply(
            [],
            [...(r[a.area.name] || []), a.selected]
          );
          return r;
        }
      }, {});
      return grouped_;
    },
    hasArrangements() {
      return this.model.arrangements.length > 0;
    },
  },
  methods: {
    fetchArrengementListByArea(selectedArea) {
      if (selectedArea) {
        let self = this;
        self
          .$ApiGet(`api/code/getallpeiservicearrangement/${selectedArea.id}`)
          .then((response) => {
            let results = [];
            this.arrangement.temporary = results;
            if (self.model.arrangements.length > 0) {
              let toRemove = self.model.arrangements
                .filter((k) =>
                  k.selected.filter((e) =>
                    response.data.filter((d) => e.id === d.id)
                  )
                )
                .reduce(function(a, b) {
                  return a.concat(b.selected);
                }, []);
              results = response.data.filter(function(el) {
                return toRemove.every((d) => el.id !== d.id);
              });
            } else {
              results = response.data;
            }
            self.strategyList = results;
          })
          .catch((errm) => {
            self.ShowToast(errm.message, '', 'error');
          });
      }
    },
    ModifyHandler() {
      this.arrangement.isModified = true;
      this.arrangement.temporary = this.arrangement.selected.map((obj) => ({
        ...obj,
      }));
    },
    FilterHandler() {
      this.strategyList = [];
      this.fetchArrengementListByArea(this.selectedArea);
      this.$emit('onFilterArrangement', this.selectedArea);
    },
    UpdateRecordsHandler(arrangement) {
      let exitRecord = this.model.arrangements.find(
        (tmp) => tmp.area.id === this.selectedArea.id
      );
      if (exitRecord != null) {
        this.model.arrangements.forEach((a) => {
          if (a.area.id === exitRecord.area.id) {
            a.selected = a.selected.concat(arrangement.selected);
          }
        });
      } else {
        this.model.arrangements.push(arrangement);
      }
    },
    async SaveHandler() {
      let isvalid = this.arrangement.temporary.length > 0;
      if (isvalid) {
        let arrangement = {
          area: this.selectedArea,
          selected: this.arrangement.temporary.map((x) => {
            x.areaId = this.selectedArea.id;
            return x;
          }),
        };
        this.UpdateRecordsHandler(arrangement);
        this.$emit('onSaveArrangement', arrangement);
      }
      this.ClearData(isvalid);
    },
    RemoveTempHandler(item) {
      this.arrangement.temporary = this.arrangement.temporary.filter(
        (tmp) => tmp.id !== item.id
      );
    },
    RemoveHandler(item) {
      this.model.arrangements.forEach((arrangement) => {
        if (arrangement.area.id === item.areaId) {
          arrangement.selected = arrangement.selected.filter(
            (tmp) => tmp.id !== item.id
          );
          if (arrangement.selected.length === 0) {
            this.RemoveAreaIdHandler(arrangement.area.id);
          }
        }
      });
      this.$emit('onRemoveArrangement', item);
    },
    RemoveAreaIdHandler(areaId) {
      this.model.arrangements = this.model.arrangements.filter(
        (tmp) => tmp.area.id !== areaId
      );
      this.$emit('onRemoveArea', areaId);
    },
    RemoveArrangementHandler(arrangements) {
      this.RemoveAreaIdHandler(arrangements[0].areaId);
      this.$emit('onRemoveArrangements', arrangements);
    },
    OnItemSelectedHandler(item) {
      this.$emit('onItemSelectedArrangement', item);
    },
    CloseHandler() {
      this.$emit('fetchArrangement');
      this.ClearData(true);
    },
    ClearData(isvalid) {
      this.arrangement.isModified = !isvalid;
      this.arrangement.temporary = [];
      this.arrangement.items = [];
      this.arrangement.selected = [];
      this.selectedArea = null;
      this.strategyList = [];
    },
  },
};
</script>

<style scoped src="@/assets/css/component/panel-simple.css"></style>
<style scoped>
.divpanelacomodos {
  font: normal normal normal 14px/28px Lato;
  border-radius: 4px;
}
.close-border {
  border: 1px solid #2db782;
  border-radius: 50px;
  display: inline-block;
  font-family: 'Lato', sans-serif;
  font-weight: 400;
  font-size: 1.125rem;
  line-height: 1.6em;
  text-align: center;
  width: 7.1875rem;
  height: 2.6875‬rem;
  cursor: pointer;
  color: #2db782;
}

.close-ico {
  color: #2db782;
  margin-right: 3px;
}

.fa-times-circle {
  font-size: 18px;
  vertical-align: top;
}

.fa-orange {
  color: #ff7058;
}

.badge-orange {
  background-color: #ff7058;
  border: 1px solid #ff7058;
}

.badge-disable {
  background-color: transparent;
  border: 1px solid #b5c3bc;
  text-align: left;
  font: Regular 16px/19px Lato;
  letter-spacing: 0;
  color: #11291b;
  opacity: 1;
}

.thead-property {
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 5px 5px 0px 0px;
}

.title-section {
  text-align: left;
  font: Bold 16px/19px Lato;
  letter-spacing: 0;
  color: #11291b;
}

.info-titule {
  margin-left: 17px;
  margin-top: -35px;
  margin-bottom: 20px;
  text-align: left;
  font: Bold 14px/17px Lato;
  letter-spacing: 0;
  color: #727272;
  opacity: 1;
}

.custompadding {
  padding: 1.2rem 0rem 1.2rem 2rem !important;
}

.list-group-item.text-center {
  background: #fafbfa !important;
  padding: 1rem !important;
}

.readonly {
  width: 210px !important;
  height: 40px !important;
}

.tag-badge {
  display: inline-block;
  padding-right: 1em;
  padding-bottom: 0.5%;
  background: transparent linear-gradient(90deg, #ffffff 0%, #e8e8e8 100%) 0% 0%
    no-repeat padding-box;
  border-radius: 26px;
  cursor: pointer;
}

.dot {
  width: 33px;
  height: 33px;
  border-radius: 50%;
  display: inline-block;
  opacity: 1;
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 10px #00000029;
  padding-top: 7px;
}

.orange-icon {
  color: #ff7058;
  font-size: 15pt;
  padding-right: 4px;
  line-height: 23px;
}

.orange-icon-badge-align {
  vertical-align: top;
}

.tag-badge-title {
  text-align: left;
  font: Bold 18px/22px Lato;
  letter-spacing: 0;
  color: #11291b;
}

.alert-warning {
  background: transparent;
  border: 0px;
  opacity: 1;
  letter-spacing: var(--unnamed-character-spacing-0);
  text-align: left;
  letter-spacing: 0px;
  color: #f8b539;
  opacity: 1;
}

.alert-warning span {
  font: normal normal normal 14px/28px Lato;
  color: #f8b539;
}

.alert-icon {
  float: left;
  padding-top: 0.75%;
}

.alert-content {
  margin-left: 1.5%;
}

.btnadd {
  width: 103px;
  height: 38px;
  margin: 15px;
}

.deletepadding {
  padding: 40px;
}

.font16 {
  font: normal normal normal 16px/19px Lato;
}
.font14 {
  font: normal normal normal 14px/28px Lato;
}
.groupname {
  font-weight: bold;
}
.input-label {
  color: var(--gray);
  text-align: left;
  font: normal normal normal 14px/17px Lato;
  letter-spacing: 0px;
  color: #727272;
  opacity: 1;
}

.rowAcomodoform {
  background: var(--unnamed-color-f7f7f7) 0% 0% no-repeat padding-box;
  background: #f7f7f7 0% 0% no-repeat padding-box;
  border-radius: 5px;
  opacity: 1;
}
.input-label {
  color: #727272;
  font-size: 15px;
  font-weight: lighter;
}
.rowAcomodoform >>> .input-label {
  font-weight: normal;
}
#acomodos >>> i.icon-right {
  display: flex;
  align-items: center;
  font-size: 16px;
}
@media only screen and (min-width: 768px) {
  .padding-10 {
    padding: 10px;
  }
}
</style>
